module.exports = __webpack_public_path__ + "static/media/2.e46101c5.svg";